const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const apiService = {
  async getAllPosters(latitude, longitude) {
    try {
      const response = await fetch(`${API_BASE_URL}/posters/${latitude}/${longitude}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching posters:', error);
      throw error;
    }
  },

  async submitPoster(posterData) {
    try {
      const response = await fetch(`${API_BASE_URL}/posters/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(posterData)
      });

      if (!response.ok) {
        if (response.status === 429) {
          throw new Error('Too many submissions. Please try again later.');
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error submitting poster:', error);
      throw error;
    }
  }
}; 